export default __webpack_public_path__ + "assets/images/ce70530bbd04f2ccd9cc281cae76fb66.svg";